window.onscroll = function () {
  addClassOnScroll();
};

function addClassOnScroll() {
  if (
    document.documentElement.scrollTop > 100 ||
    document.body.scrollTop > 100
  ) {
    document.getElementById("thesaletimers").classList.add("scrolled");
  } else {
    document.getElementById("thesaletimers").classList.remove("scrolled");
  }
}
